export default __webpack_public_path__ + "static/media/GZ.6eced49b.txt";